var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"d":"M0,0V31.57H42.09V0ZM4.21,4.21H37.88v.61L21,19.61,4.21,4.8ZM4.4,27.78,4.24,9.31,21,24.13,37.73,9,38,27.78Z"}))));
}

Mail.defaultProps = {"viewBox":"0 0 42.09 31.57"};

module.exports = Mail;

Mail.default = Mail;
